import { memo } from 'react';
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../../../components";
import { Container, Row, Col } from "react-bootstrap";
import moment from 'moment';
import PlaceNfoOrder from './PlaceNfoOrder';
import { handleModal } from "../../../../redux/actions/modals";
import { useSelector, useDispatch } from "react-redux";


const NfoDetails = ({ nfoDetails }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const handleOnBuy = () => {
        dispatch(handleModal([{ 'NFO_DETAILS': false }, { 'PLACE_NFO_ORDER': true }]));

    };
    const handleClose = () => {
        dispatch(handleModal([{ "NFO_DETAILS": false }]));
    };

    return (
        <>
            <BzModal show={modals['NFO_DETAILS']} onHide={handleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>NFO Details</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start */}
                    <Container fluid className='p-0'>
                        <Row className='g-0 mt-2'>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col clsaaName='flex-column'>
                                        <div className='font-medium font-size5 color-text'>{nfoDetails?.scheme_name}</div>
                                        <div className='chips-wrap flex-wrap pb-3'>
                                            {/* {nfoDetails?.fundcategory?.map((category, index) => {
                                                return <BzChip key={index} className='chips primary-chip me-2 mb-2'>{category}</BzChip>;
                                            })} */}
                                            <BzChip className='chips primary-chip me-2 mb-2'>{nfoDetails?.scheme_type}</BzChip>;
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className='g-0 mt-2'>
                            <Col>
                                <Row className='g-0 pb-3'>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size3 color-subtext'>Minimum investement</div>
                                        <div className='font-regular font-size4 color-text'>&#8377;{nfoDetails?.add_in_investment_amount_for_existing_investors}</div>
                                    </Col>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size3 color-subtext'>ISIN</div>
                                        <div className='font-regular font-size4 color-text'>{nfoDetails?.isin}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-3  pb-3'>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size3 color-subtext'>Open Date</div>
                                        <div className='font-regular font-size4 color-text'>{moment(nfoDetails?.launch_date).format("DD MMM 'YY")}</div>
                                    </Col>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size3 color-subtext'>Close Date</div>
                                        <div className='font-regular font-size4 color-text'>{moment(nfoDetails?.end_date).format("DD MMM 'YY")}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-3'>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size3 color-subtext'>AMC</div>
                                        <div className='font-regular font-size4 color-text'>{nfoDetails?.amc_name}</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                    {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End */}
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col>
                                <BzButton className='btn btn-md btn-positive' onClick={handleOnBuy}>BUY</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

            <PlaceNfoOrder nfoDetails={nfoDetails} />

        </>
    );
};
export default memo(NfoDetails);